'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _guidDetails = require('@marmalade/guid-details');
var hasProp = Object.prototype.hasOwnProperty;
exports.default = function (state) {
  var details = (0, _guidDetails.guidDetails)(state);
  if (hasProp.call(details, 'payOnAccount')) {
    return details.payOnAccount;
  }
  return false;
};